import { useMemo } from 'react'
import { ResetPasswordOutcome } from '@/screens/reset-password/ResetPasswordOutcome'
import { pickLink, readResultLinks } from '@/screens/reset-password/resultLinks'
import locales from '@/screens/reset-password/locales/pt-BR.json'

/**
 * S8 — tela `reset-password-error` do Auth0: link de recuperação expirado,
 * já usado ou inválido. O botão só aparece quando o Auth0 manda o caminho
 * para pedir um novo link; sem ele, a mensagem explica como fazer.
 */
export default function ResetPasswordErrorScreen() {
  const { inUniversalLogin, links } = useMemo(readResultLinks, [])
  const target = inUniversalLogin
    ? pickLink(links, /reset|request|forgot/i)
    : '?screen=reset-password-request'

  return (
    <ResetPasswordOutcome
      tone="negative"
      title={locales.expiredTitle}
      message={locales.expiredLink}
      action={
        target
          ? { label: locales.requestNewLink, onClick: () => window.location.assign(target) }
          : undefined
      }
      hint={locales.expiredHint}
    />
  )
}
